import {ChangeDetectorRef, Directive} from '@angular/core';

@Directive({
    selector: '[appCdr]',
    exportAs: 'appCdr'
})
export class CdrDirective  {
    constructor(public cdRef: ChangeDetectorRef) {}
}
